import React from 'react'
import View from './view'

const BookingHome = ({ ...props }) => {
    return <View {...props} />
}

export default BookingHome
